module.exports = __webpack_public_path__ + "img/DE00164.a8b125f3.png";